import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { downloadInvoicePdf } from "../../utils/invoicePdf";

const InvoicePreview = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const invoiceData = location.state?.invoiceData;

  useEffect(() => {
    if (!invoiceData) {
      navigate("/invoice");
      return;
    }

    // OPEN PDF PREVIEW
    downloadInvoicePdf(invoiceData, "preview");

  }, [invoiceData, navigate]);

  return null;
};

export default InvoicePreview;